import React from "react";

const Footer = () => {
  return (
    <footer className="footer mt-auto py-3 bg-white text-center">
      <div className="container">
        <span className="text-muted">
          {" "}
          Copyright © <span id="year">{new Date().getFullYear()}</span>{" "}
          <a
            href="https://itmedia.io/"
            target={"_blank"}
            rel={"noreferrer"}
            className="text-dark fw-medium"
          >
            itMedia
          </a>{" "}
          All rights reserved
        </span>
      </div>
    </footer>
  );
};

export default Footer;
